import { render, staticRenderFns } from "./EffluentsGranting.vue?vue&type=template&id=72dccb9a&scoped=true"
import script from "./EffluentsGranting.vue?vue&type=script&lang=js"
export * from "./EffluentsGranting.vue?vue&type=script&lang=js"
import style0 from "./EffluentsGranting.vue?vue&type=style&index=0&id=72dccb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dccb9a",
  null
  
)

export default component.exports